export const generateMapForCars = (properties) => {
    const cars = JSON.stringify(properties.cars);
    const center = properties.center;
    const selectedRoutes = JSON.stringify(properties.selectedRoutes);
    const zoom = properties.zoom;
    const refuels = JSON.stringify(properties.seletedRefuels);
    const currentRoute = JSON.stringify(properties.currentRoute);
    const generatedMap = document.implementation.createHTMLDocument('mapa');
    generatedMap.documentElement.innerHTML = `
    <!DOCTYPE html>
    <html>
    <head>
        <title>ETS - Mapa</title>

        <meta charset="utf-8" />

        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <link rel="shortcut icon" type="image/x-icon" href="http://ets-admin-panel.herokuapp.com/static/media/carPin.dbd65467.svg" />
        <link rel="stylesheet" href="http://cdn.leafletjs.com/leaflet-0.7.3/leaflet.css" />
        <script src="http://cdn.leafletjs.com/leaflet-0.7.3/leaflet.js"></script>

        <link rel="stylesheet" href="https://leaflet.github.io/Leaflet.markercluster/dist/MarkerCluster.css" />
        <link rel="stylesheet" href="https://leaflet.github.io/Leaflet.markercluster/dist/MarkerCluster.Default.css" />
        <script src="https://api.tiles.mapbox.com/mapbox.js/plugins/leaflet-markercluster/v0.4.0/leaflet.markercluster.js"></script>

        <link rel="stylesheet" href="https://cdn.rawgit.com/Leaflet/Leaflet.label/0.8/dist/leaflet.label.css" />
        <script src="https://cdn.rawgit.com/Leaflet/Leaflet.label/0.8/dist/leaflet.label.js"></script>

        <style>
            html, body {
                height: 100%;
                margin: 0;
                background: rgba(67,66,93, 0.9);
                font-family: sans-serif;
            }
            #map {
				box-sizing: border-box;
                width: 80%;
                height: 100vh;
				display: inline-block;
            }
			#carListPanel{
				float:left;
				clear:none;
				box-sizing: border-box;
				display: inline-block;
				width: 20%;
                height: 100vh;
                overflow: auto;
			}

            .marker-cluster-small {
                font-size: 12px;
                font-weight: 900;
                height: 25px;
                width: 25px;
                background-color: #FF0000;
                color: #FFF;
            }

            .marker-cluster-small div {
                background-color: #FF0000;
            }

            .marker-cluster-medium {
                font-size: 15px;
                font-weight: 900;
                height: 35px;
                width: 35px;
                background-color: #FF0000;
                color: #FFF;
            }

             .marker-cluster-medium div {
                background-color: #FF0000;
            }

             .marker-cluster-large {
                font-size: 18px;
                font-weight: 900;
                height: 45px;
                width: 45px;
                background-color: #FF0000;
                color: #FFF;
            }

            .marker-cluster-large div {
                background-color: #FF0000;
            }

            .marker-cluster-largeXL {
                font-size: 20px;
                font-weight: 900;
                height: 55px;
                width: 55px;
                background-color: #FF0000;
                color: #FFF;
            }

            .marker-cluster-largeXL div {
                background-color: #FF0000;
            }

            .leaflet-label{
                margin-top: -5px;
               border: 1px solid #000;
               border-radius: 15px;
               background: #6F6F6F;
               width: 63px;
               font-size: x-small;
               color: #FFF;
               text-align: center;
               padding: 0;
            }

            .leaflet-label:before{
                border-right: none;
            }

            .single-car {
                margin: 8px;
                background: #34344A;
                color: white;
                margin-top: 8px;
            }

            .single-car-info {
                display: flex;
            }

            .single-car-registration {
                 font-size: 1.25rem;
                 color: #FFD1A4;
                 margin-left: 16px;
                 padding: 8px 0;
            }

            .container {
                margin: 0 8px;
            }

            .container hr {
                margin: 0;
            }

            .single-route {
                color: black;
                background: #C6C6E8;
                font-size: 0.75rem;
                display: flex;
            }

            .info-container {
                display: block;
                margin-left: 8px;
                padding: 8px 0;
                width: 100%;
            }

            .current-route {
                color: black;
                background: lime;
                font-size: 0.75rem;
                display: flex;
            }

            .checkbox {
                margin-top: auto;
                margin-bottom: auto;
                margin-right: 8px;
            }

            .refuels {
                color: black;
                background: #00AF80;
                font-size: 0.75rem;
                display: flex;
            }

            .avatar {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 62px;
                height: 62px;
                border-radius: 50%;
                border: 1px solid #A5A4BF;
                margin-left: 16px;
            }

            .car-info {
                display: inline-block;
                color: white;
                margin-left: 16px;
                font-size: 0.75rem;
            }

            hr {
                 margin-top: 0;
            }

            #legend {
                height: 20vh;
                width: 100%;
                float: right;
                color: white;
            }

            .legend-table {
                margin-left: 10%;
                width: 90%;
                height: 100%;
            }

            .legend-icon{
                vertical-align: middle;
                width: 36px;
                height: 25px;
                margin-right: 10px;
            }

            .other-icon {
                vertical-align: middle;
                width: 15px;
                height: 25px;
                margin-right: 26px;
                margin-left: 5px;
            }

            td {
                color: white;
                width: 33%;
                height: 25%;
            }
            .line{
                margin-right: 10px;
            }
            #summary {
                position: absolute;
                top: 2px;
                left 5px;
                z-index: 1;
                min-height: 25;
                display: flex;
                justify-content: flex-start;
                background: rgba(255, 255, 255, 0.8);
                border-radius: 10px 10px;
                margin-left: 8px;
            }
            .summary-info {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
            }
            .summary-single-info {
                padding: 0 16px;
            }
            @media (max-width: 960px) {
                .summary-info {
                    flex-direction: column;
                    align-items: unset
                }
                .summary-single-info {
                    padding: 8px;
                }
              }
        </style>

        <script>
            const cars = ${cars};
            let selectedRoutes = ${selectedRoutes}
            let refuels =${refuels}
            let currentRoute =${currentRoute}
        </script>
    </head>

    <body>
        <div id='carListPanel'></div>
        <div id='map'>
            <div id='summary'></div>
        </div>
        <div id='legend'></div>
    </body>

    <script>
        var LeafIcon = L.Icon.extend({
            options: {
                iconSize:     [55, 40],
                iconAnchor:   [25, 0],
                popupAnchor:  [0, 0]
            }
        });

        var PinIcon = L.Icon.extend({
            options: {
                iconSize:     [50, 50],
                iconAnchor:   [25, 50],
                popupAnchor:  [0, -50]
            }
        });

        const carIconUrl = 'http://ets-admin-panel.herokuapp.com/static/media/carPin.dbd65467.svg';
        const motorcycleIconUrl = 'http://ets-admin-panel.herokuapp.com/static/media/motorMapIcon2.a606f970.png';
        const startPinIconUrl = 'http://ets-admin-panel.herokuapp.com/static/media/startRoutePin.63e96204.png';
        const finishPinIconUrl = 'http://ets-admin-panel.herokuapp.com/static/media/finishRoutePin.570b2e95.png';
        const refuelPinIconUrl = 'http://ets-admin-panel.herokuapp.com/static/media/fuelPin.e32054f4.png';
        const dangerPinUrl = 'http://ets-admin-panel.herokuapp.com/static/media/dangerPin.c4793f58.png';

        const otherIconUrl = 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png'

        var allRoutes = [];
        var allRefuels = [];
        var routesLayers = [];
        var drawedCurrentRoute = {};

        var carIcon = new LeafIcon({iconUrl: carIconUrl});
        var startPinIcon = new PinIcon({iconUrl: startPinIconUrl});
        var finishPinIcon = new PinIcon({iconUrl: finishPinIconUrl});
        var refuelPinIcon = new PinIcon({iconUrl: refuelPinIconUrl});

        var sedanLight = "http://ets-admin-panel.herokuapp.com/static/media/sedanDark.62b37dd5.svg"
        var sedanDark = "http://ets-admin-panel.herokuapp.com/static/media/sedanLight.cc065e7d.svg";
        var carsOnMap = L.markerClusterGroup();

        for(var i=0; i<cars.length; i++){
            var car = L.marker([cars[i].pozycja_gps.lat, cars[i].pozycja_gps.lon], {icon: carIcon}).bindPopup('Rejestracja: '+ cars[i].rejestracja +
            '<br>Samochód: ' + cars[i].marka + ' ' + cars[i].model);
            car.bindLabel(cars[i].rejestracja, { noHide: true, offset: [-25, 40]});
            car.addTo(carsOnMap);
        }

        var layer = L.tileLayer('https://mapa.qsafe24.com.pl/osm/{z}/{x}/{y}.png', {
            attribution: '<a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        });

	    var map = L.map('map', {
		    center: [${center.lat}, ${center.lng}],
		    zoom: ${zoom},
		    layers: [layer, carsOnMap]
        });

        map.zoomControl.setPosition('topright');

        if(selectedRoutes){
            selectedRoutes.forEach(selectedRoute => {

                var startPin = L.marker([selectedRoute.route[0].lat, selectedRoute.route[0].lon], {icon: startPinIcon})
                .bindPopup('Początek trasy<br>Data: ' + selectedRoute.startDate
                + '<br>Stan licznika: ' + selectedRoute.route[0].dystans_przed
                + 'km<br>Stan paliwa: ' + selectedRoute.route[0].stan_paliwa_przed + 'l(' + Math.round(selectedRoute.route[0].stan_paliwa_procent_przed * 100) + '%)'
                + (selectedRoute.route[0].adres ? '<br>' + selectedRoute.route[0].adres : ''));

                var finishPin = L.marker([selectedRoute.route[selectedRoute.route.length - 1].lat, selectedRoute.route[selectedRoute.route.length - 1].lon], {icon: finishPinIcon})
                .bindPopup('Koniec trasy<br>Data: ' + selectedRoute.startDate
                + '<br>Stan licznika: ' + selectedRoute.route[selectedRoute.route.length - 1].dystans_po
                + 'km<br>Stan paliwa: ' + selectedRoute.route[selectedRoute.route.length - 1].stan_paliwa_po + 'l(' + Math.round(selectedRoute.route[selectedRoute.route.length - 1].stan_paliwa_procent_po * 100) + '%)'
                + (selectedRoute.route[selectedRoute.route.length - 1].adres ? '<br>' + selectedRoute.route[selectedRoute.route.length - 1].adres : ''));

                var pLineGroup = L.layerGroup();
                for(var i=0; i<selectedRoute.route.length; i++){
                    var latlngs = [];
                    latlngs.push([selectedRoute.route[i].lat, selectedRoute.route[i].lon]);
                    if(i+1 <selectedRoute.route.length){
                        latlngs.push([selectedRoute.route[i+1].lat, selectedRoute.route[i+1].lon]);
                    }
                        pLineGroup.addLayer(L.polyline(latlngs, {color: selectRouteColor(selectedRoute.route[i].predkosc_dopuszczalna, selectedRoute.route[i].predkosc), opacity: 1}));
                }
                routesLayers.push(pLineGroup);

                const routeToDraw = {
                    id: selectedRoute.id,
                    routeParts: pLineGroup,
                    selected: selectedRoute.selected,
                    startPin: startPin,
                    finishPin: finishPin,
                    distance: selectedRoute.distance,
                    averageSpeed: selectedRoute.averageSpeed,
                    timeDiff: selectedRoute.timeDiffInSeconds,
                };

                allRoutes.push(routeToDraw);
            })

            refuels.forEach(refuel => {
                var refuelPin = L.marker([refuel.lat, refuel.lon], {icon: refuelPinIcon})
                .bindPopup('Data: ' + refuel.date
                + '<br>Tankowanie: ' + refuel.liters + ' l');

                const refuelToDraw = {
                    id: refuel.id,
                    selected: refuel.selected,
                    refuelPin: refuelPin,
                };

                allRefuels.push(refuelToDraw);
            });
        }

        if(currentRoute && Object.keys(currentRoute).length !== 0){

            var startPin = L.marker([currentRoute.route[0].lat, currentRoute.route[0].lon], {icon: startPinIcon})
            .bindPopup('Początek trasy<br>Data: ' + currentRoute.startDate
            + '<br>Stan licznika: ' + currentRoute.route[0].dystans_przed
            + 'km<br>Stan paliwa: ' + currentRoute.route[0].stan_paliwa_przed + 'l(' + Math.round(currentRoute.route[0].stan_paliwa_procent_przed * 100) + '%)'
            + (currentRoute.route[0].adres ? '<br>' + currentRoute.route[0].adres : ''));

            var pLineGroup = L.layerGroup();
            for(var i=0; i<currentRoute.route.length; i++){
                var latlngs = [];
                latlngs.push([currentRoute.route[i].lat, currentRoute.route[i].lon]);
                if(i+1 <currentRoute.route.length){
                    latlngs.push([currentRoute.route[i+1].lat, currentRoute.route[i+1].lon]);
                }
                    pLineGroup.addLayer(L.polyline(latlngs, {color: selectRouteColor(currentRoute.route[i].predkosc_dopuszczalna, currentRoute.route[i].predkosc), opacity: 1}));
            }

            const routeToDraw = {
                id: 'current-route',
                routeParts: pLineGroup,
                selected: currentRoute.selected,
                startPin: startPin,
            };

            drawedCurrentRoute = routeToDraw;

            drawCurrentRoute(drawedCurrentRoute);
        }

        allRoutes.forEach((route) => {
            if(route.selected){
                drawRoute(route);
            }
        })

        allRefuels.forEach((refuel) => {
            if(refuel.selected){
                drawRefuelMarker(refuel);
            }
        })



        var carListPanelElement = document.getElementById("carListPanel");

        cars.forEach(car => {

            var singleCarDiv = htmlToElement(
                '<div class="single-car">' +
                    '<div class="single-car-registration">'+
                        car.rejestracja +
                    '</div>' +
                    '<hr>' +
                    '<div class="single-car-info">' +
                        '<div class="avatar">' +
                            '<img src="' + evaluateType('Sedan', 'light') + '" width="55" height="40">' +
                        '</div>' +
                        '<div class="car-info">' +
                            '<div>' +
                                car.marka + " " + car.model +
                            '</div>' +
                            '<div>' +
                                car.dystans + "km/h " + car.predkosc + "km/h " +
                            '</div>' +
                            '<div>' +
                                car.stanPaliwa + " l ("+ car.stanPaliwaProcent +"%) / " + car.typPaliwa +
                            '</div>' +
                            '<div>' +
                                car.adres +
                            '</div>' +
                            '<div>' +
                                car.ostatniaAktualizacja +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>');

            carListPanelElement.appendChild(singleCarDiv);

            if(currentRoute && Object.keys(currentRoute).length !== 0) {
                var currentRouteDiv = htmlToElement(
                    '<div class="container">' +
                        '<div class="current-route">' +
                            '<div class="info-container">' +
                                '<div>' +
                                    '<div>' +
                                        "Pojazd w trasie od:" + currentRoute.startDate +
                                    '</div>' +
                                    '<div>' +
                                        "Kierowca: " + currentRoute.driver +
                                    '</div>' +
                                    '<div>' +
                                        "Maksymalna prędkość: " + currentRoute.maxSpeed + " km/h" +
                                    '</div>' +
                                    '<div>' +
                                        "Średnia prędkość: " + currentRoute.averageSpeed + " km/h" +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                            '<div class="checkbox">' +
                                '<input type="checkbox" id="' + drawedCurrentRoute.id + '">' +
                            '</div>' +
                        '</div>' +
                        '<hr>' +
                    '</div>');

                carListPanelElement.appendChild(currentRouteDiv);

                var currentRouteCheckbox = document.getElementById(drawedCurrentRoute.id);
                if(drawedCurrentRoute.selected){
                    currentRouteCheckbox.checked = true;
                }

                currentRouteCheckbox.addEventListener('change', (event) => {
                    if (event.currentTarget.checked) {
                        drawCurrentRoute(drawedCurrentRoute);
                    } else {
                        removeCurrentRouteFromMap(drawedCurrentRoute);
                    }
                })
            }

            if(selectedRoutes){
                selectedRoutes.forEach(selectedRoute => {
                    var displayedDistance = selectedRoute.distance === 0 ? "<1" : selectedRoute.distance;
                    var routesDiv = htmlToElement(
                        '<div class="container">' +
                            '<div class="single-route">' +
                                '<div class="info-container">' +
                                    '<div>' +
                                        '<div>' +
                                            "Od:" + selectedRoute.startDate +
                                        '</div>' +
                                        '<div>' +
                                            "Do:" + selectedRoute.endDate +
                                        '</div>' +
                                        '<div>' +
                                            "Kierowca: " + selectedRoute.driver +
                                        '</div>' +
                                        '<div>' +
                                            "Dystans: " + displayedDistance + " km" +
                                        '</div>' +
                                        '<div>' +
                                            "Maksymalna prędkość: " + selectedRoute.maxSpeed + " km/h" +
                                        '</div>' +
                                        '<div>' +
                                            "Średnia prędkość: " + selectedRoute.averageSpeed + " km/h" +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="checkbox">' +
                                    '<input type="checkbox" id="route-' + selectedRoute.id + '">' +
                                '</div>' +
                            '</div>' +
                        '<hr>' +
                        '</div>'
                        );

                    carListPanelElement.appendChild(routesDiv);
                })

                refuels.forEach(refuel => {
                    var refuelsDiv = htmlToElement(
                        '<div class="container">' +
                            '<div class="refuels">' +
                                '<div class="info-container">' +
                                    '<div>' +
                                        "Data:" + refuel.date +
                                    '</div>' +
                                    '<div>' +
                                        "Zatankowano:" + refuel.liters + " l" +
                                    '</div>' +
                                '</div>' +
                                '<div class="checkbox">' +
                                    '<input type="checkbox" id="refuel-' + refuel.id + '">' +
                                '</div>' +
                            '</div>' +
                            '<hr>' +
                        '</div>'
                    );

                    carListPanelElement.appendChild(refuelsDiv);
                });

                selectedRoutes.forEach(selectedRoute => {
                    var routeCheckbox = document.getElementById("route-" + selectedRoute.id);
                    if(selectedRoute.selected){
                        routeCheckbox.checked = true;
                    }

                    routeCheckbox.addEventListener('change', (event) => {
                        if (event.currentTarget.checked) {
                            drawRoute(allRoutes.find(route => route.id === selectedRoute.id));
                            calculateSummary();
                        } else {
                            removeRouteFromMap(allRoutes.find(route => route.id === selectedRoute.id));
                            calculateSummary();
                        }
                    })

                })

                refuels.forEach(selectedRefuel => {
                    var refuelCheckbox = document.getElementById("refuel-" + selectedRefuel.id);
                    if(selectedRefuel.selected){
                        refuelCheckbox.checked = true;
                    }

                    refuelCheckbox.addEventListener('change', (event) => {
                        if (event.currentTarget.checked) {
                            drawRefuelMarker(allRefuels.find(refuel => refuel.id === selectedRefuel.id));
                        } else {
                            removeRefuelMarker(allRefuels.find(refuel => refuel.id === selectedRefuel.id));
                        }
                    })

                })
            }

        });

        var legendElement = document.getElementById("legend");

        var legendDiv = htmlToElement(
                '<table class="legend-table">'+
                    '<tr>' +
                        '<td>' +
                            '<img class="legend-icon" src="'+ carIconUrl + '" /> Samochód'+
                        '</td>'+
                        '<td>' +
                            '<img class="legend-icon" src="'+ startPinIconUrl + '" /> Początek trasy'+
                        '</td>'+
                        '<td>' +
                        createSvgLine("#a3469e") + ' Odcinek bez przekroczeń'+
                        '</td>'+
                    '</tr>' +
                    '<tr>' +
                        '<td>' +
                            '<img class="legend-icon" src="' + motorcycleIconUrl + '"/> Motocykl'+
                        '</td>'+
                        '<td>' +
                            '<img class="legend-icon" src="'+ finishPinIconUrl + '" /> Koniec trasy'+
                        '</td>'+
                        '<td>' +
                            createSvgLine("#f4853f") + ' Przekroczenie 10 - 30 km/h'+
                        '</td>'+
                    '</tr>' +
                    '<tr>' +
                        '<td class="outside-zone">' +
                            createSvgLine("#FF0000", 0.3) + '<span style="color:white;"> Rejonizacja<span>' +
                        '</td>'+
                        '<td>' +
                            '<img class="legend-icon" src="' + refuelPinIconUrl+ '"/> Tankowanie'+
                        '</td>'+
                        '<td>' +
                            createSvgLine("#ff0000") + ' Przekroczenie > 30 km/h'+
                        '</td>'+
                    '</tr>' +
                    '<tr>' +
                        '<td>' +
                            '<img class="other-icon" src="'+ otherIconUrl + '" /> Inne'+
                        '</td>'+
                        '<td>' +
                            '<img class="legend-icon" src="' + dangerPinUrl + '" /> Zdarzenie'+
                        '</td>'+
                        '<td>' +
                        createSvgLine("#000000") + ' Przekroczenie > 50 km/h'+
                        '</td>'+
                    '</tr>' +
                '</table>'
        );

        legendElement.appendChild(legendDiv);

        calculateSummary();

        function htmlToElement(html) {
            var carList = document.createElement('template');
            html = html.trim();
            carList.innerHTML = html;
            return carList.content.firstChild;
        }


		function selectRouteColor(speedLimit, speed){
			if (speedLimit === -1 || speed < speedLimit)
				return "#a3469e";

			if (speed >= speedLimit + 10 && speed <= speedLimit + 30)
				return "#f4853f";

			if (speed > speedLimit + 30 && speed <= speedLimit + 50)
				return "#ff0000";

			if (speed > speedLimit + 50)
				return "#000000";

			return "#a3469e";
		};

        function drawRoute(route) {
            route.selected = true;

            route.routeParts.addTo(map);
            route.startPin.addTo(map);
            route.finishPin.addTo(map);
        }

        function removeRouteFromMap(route) {
            route.selected = false;

            map.removeLayer(route.routeParts);
            map.removeLayer(route.startPin);
            map.removeLayer(route.finishPin);
        }

        function drawRefuelMarker(refuel) {
            refuel.selected = true;
            refuel.refuelPin.addTo(map);
        }

        function removeRefuelMarker(refuel) {
            refuel.selected = false;
            map.removeLayer(refuel.refuelPin);
        }

        function drawCurrentRoute(route){
            route.selected = true;
            route.startPin.addTo(map);
            route.routeParts.addTo(map);
        }

        function removeCurrentRouteFromMap(route){
            route.selected = false;
            map.removeLayer(route.routeParts);
            map.removeLayer(route.startPin);
        }

        function calculateSummary(){
            var summaryElement = document.getElementById("summary");

            const selectedRoutesOnly = allRoutes.filter((route) => route.selected === true);

            if(selectedRoutesOnly.length > 0) {
                summaryElement.style.display = "flex";
                const summaryDistance = selectedRoutesOnly.reduce((accu, b) => accu + b.distance, 0);

                const summaryAverage = Math.round(selectedRoutesOnly.reduce((accu, b) => accu + b.averageSpeed, 0) / selectedRoutesOnly.length);

                let summarySeconds = selectedRoutesOnly.reduce((accu, b) => accu + b.timeDiff, 0);

                const summaryHours = hours = Math.floor(summarySeconds / 3600);
                summarySeconds = summarySeconds - hours * 3600;

                const summaryMinutes = Math.floor(summarySeconds / 60);

                summaryElement.innerHTML = '<div class="summary-info">'+
                    '<div class="summary-single-info">'+
                        'Suma długości trasy: ' + summaryDistance +'km' +
                    '</div>'+
                    '<div class="summary-single-info">'+
                        'Średnia prędkość w trasie: '+ summaryAverage +'km/h' +
                    '</div>'+
                    '<div class="summary-single-info">'+
                        'Suma czasu spędzonego za kierownicą: ' + summaryHours +'h ' + summaryMinutes + 'min' +
                    '</div>'+
                '</div>';
            } else {
                summaryElement.style.display = "none";
            }
        }

        function evaluateType (type, theme){
            switch(type) {
                case "Sedan":
                //     return theme === "light" ? sedanLight : sedanDark;
                // case "Hatchback":
                //     return theme === "light" ? hatchbackLight : hatchbackDark;
                // case "SUV":
                //     return theme === "light" ? suvLight : suvDark;
                // case "Combi":
                //     return theme === "light" ? combiLight : combiDark;
                // case "Van":
                //     return theme === "light" ? vanLight : vanDark;
                // case "Motocykl":
                //     return theme === "light" ? motorbikeLight : motorbikeDark;
                // case "Sportowy":
                //     return theme === "light" ? sportLight : sportDark;
                default:
                    return theme === "light" ? sedanLight : sedanDark;
            }
        };

        function createSvgLine(color, opacity){
            return '<svg height="25" width="36" class="line"><line x1="0" y1="21" x2="30" y2="21" style="opacity:' + opacity +';stroke:'+ color +';stroke-width:4" /></svg>'
        }

    </script>

	</html>
    `;
    return generatedMap;
};